import {useState} from "react"
import cx from "classnames"
import {useQuery} from "@tanstack/react-query"
import {Icon} from "components/Icon"
import styles from "./ReopenedTaskUsers.module.css"
import {handleError} from "helpers"
import {taskService} from "services"
import moment from "moment"
import {useModel} from "hooks"
import {map} from "lodash"

export function ReopenedTaskUsers(props) {
    const model = useModel()
    const [isCollapseBody, setIsCollapseBody] = useState(false)
    const {taskData} = props

    const {data: reopenedTaskUsers = [], isLoading} = useQuery(
        ["reopened-task-users", taskData.id],
        async () => {
            const {data} = await taskService.getReopenSubTasks({taskId: +taskData.id})
            return data
        },
        {enabled: !!taskData.id, onError: (error) => handleError(error)}
    )

    const onToggleShowBody = () => {
        setIsCollapseBody(!isCollapseBody)
    }

    if (isLoading || !reopenedTaskUsers.length) {
        return null
    }

    const userDateTimeFormat = model.getUserDateTimeFormat()

    return (
        <div className={styles.wrap}>
            <div className={styles.header}>
                <div className={styles.header__icon}>
                    <Icon icon="REFRESH" color="#fff" />
                </div>
                <p className={styles.title}>{reopenedTaskUsers.length} tasks have been reopened</p>
                <div className={styles.collapse} onClick={onToggleShowBody}>
                    <Icon icon={!isCollapseBody ? "ARROW_DOWN" : "ARROW_RIGHT"} color="#fff" />
                </div>
            </div>
            <div
                className={cx(styles.body, {
                    [styles.body__show]: !isCollapseBody
                })}>
                {map(reopenedTaskUsers, (tu) => (
                    <div className={styles.item} key={tu.id}>
                        <p className={styles.item__title}>
                            Task <span className={styles.item__titleHighlight}>{tu.subtaskCode}</span> has been reopened
                            for
                            <span> {tu.userFullname}</span>{" "}
                            {tu.remarkedAt && <span> at {moment(tu.remarkedAt).format(userDateTimeFormat)}</span>}
                        </p>
                        <p className={styles.description}>{tu.remarkedReason}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}
